import { __assign } from "tslib";
import * as React from 'react';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { renderAndMountComponent } from '@wix/answers-lib';
import { SearchInput } from './search-input';
import { createLegacyDeprecatedInputDriver } from '../../primitives/deprecated-input/input.legacy-driver';
export var createLegacySearchInputDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.search-input', SearchInput.name);
    var inputDriver = createLegacyDeprecatedInputDriver(baseDriver.elem);
    return {
        getQuery: function () { return inputDriver.getValue(); },
        setQuery: function (query) { return inputDriver.enterValue(query); },
        isDisabled: function () { return inputDriver.isDisabled(); },
    };
};
export var createSearchInput = function (props) {
    var elem = renderAndMountComponent(React.createElement(SearchInput, __assign({}, props)));
    return createLegacySearchInputDriver(elem);
};
//# sourceMappingURL=search-input.legacy-driver.js.map